import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import AccordionDetails from '@mui/material/AccordionDetails';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import type { CSSProperties, ReactNode } from 'react';

type Props = {
  id: string;
  title: string;
  canToggle?: boolean;
  activexpanded?: boolean;
  titleChildren?: ReactNode;
  styleAcccordion?: CSSProperties;
  styleAcccordionDetail?: CSSProperties;
  hasAccordionSummary?: boolean;
};

function CardAccordion({
  id,
  title,
  children,
  canToggle = true,
  activexpanded = true,
  titleChildren = null,
  styleAcccordion = {},
  styleAcccordionDetail = {},
  hasAccordionSummary = true
}: Props & React.HTMLAttributes<HTMLDivElement>) {
  return (
    <Accordion
      defaultExpanded={activexpanded}
      sx={{
        ...styleAcccordion,
        padding: 2,
        background: 'rgba(245, 247, 251, 0.76)',
        borderRadius: '4px',
        margin: '10px'
      }}
    >
      {hasAccordionSummary && (
        <AccordionSummary
          aria-controls={`${id}-content`}
          expandIcon={canToggle ? <OpenInFullIcon /> : null}
          id={`${id}-header`}
          sx={{
            '.MuiAccordionSummary-content': {
              marginY: 2,
              color: '#0E335C',
              display: 'flex',
              alignItems: 'center',
              flexFlow: {
                xs: 'column',
                md: 'row'
              }
            }
          }}
        >
          <Typography fontSize={16} fontWeight={500} paddingBottom={1}>
            {title}
          </Typography>
          {titleChildren}
        </AccordionSummary>
      )}
      <AccordionDetails
        sx={{
          ...styleAcccordionDetail
        }}
      >
        {children}
      </AccordionDetails>
    </Accordion>
  );
}

export default CardAccordion;
